export const BackendReportPeriods = {
	Daily: 1,
	Weekly: 2,
	Monthly: 3,
	FinancialYear: 4,
	CalendarYear: 5,
	Custom: 5
};

export const BackendReportPeriodNames = {
	[BackendReportPeriods.Daily]: 'Yesterday',
	[BackendReportPeriods.Weekly]: 'Last Week',
	[BackendReportPeriods.Monthly]: 'Last Month',
	[BackendReportPeriods.FinancialYear]: 'This Financial Year',
	[BackendReportPeriods.CalendarYear]: 'This Calendar Year',
	[BackendReportPeriods.Custom]: 'Custom Range'
};

export const ReportPeriods = {
	Today: 1,
	Yesterday: 2,
	ThisWeek: 3,
	PreviousWeek: 4,
	ThisMonth: 5,
	PreviousMonth: 6,
	ThisYear: 7,
	PreviousYear: 8,
	ThisFinancialYear: 9,
	PreviousFinancialYear: 10,
	Lifetime: 11,
	Custom: 12
};

export const ReportPeriodNames = {
	[ReportPeriods.Today]: 'Today',
	[ReportPeriods.Yesterday]: 'Yesterday',
	[ReportPeriods.ThisWeek]: 'This Week',
	[ReportPeriods.PreviousWeek]: 'Last Week',
	[ReportPeriods.ThisMonth]: 'This Month',
	[ReportPeriods.PreviousMonth]: 'Last Month',
	[ReportPeriods.ThisYear]: 'This Year',
	[ReportPeriods.PreviousYear]: 'Last Year',
	[ReportPeriods.ThisFinancialYear]: 'This Financial Year',
	[ReportPeriods.PreviousFinancialYear]: 'Last Financial Year',
	[ReportPeriods.Lifetime]: 'Lifetime',
	[ReportPeriods.Custom]: 'Custom Range'
};
